import React from "react";
import { Download, Filter as FilterIcon } from "lucide-react";

import { PackagesReportController } from "../../../../services/controllers/reports";
import { usePackagesReport } from "../../../../store/reports/usePackagesReport";

import { Filter } from "../../../../components/ui/Filter";
import { CAMPO } from "../../../../components/ui/Filter/sizes";
import { Input } from "../../../../components/ui/Form/Input";
import { Select } from "../../../../components/ui/Form/Select";

export function PackagesReportFilter() {
  const CPackagesReport = PackagesReportController();

  const filter = usePackagesReport((st) => st.data.filter);
  const isLoading = usePackagesReport((st) => st.data.isLoading);
  const total = usePackagesReport((st) => st.data.pagination.totalDocuments);

  return (
    <Filter.Root onSubmit={CPackagesReport.filterPackages}>
      <Filter.Container>
        <Select.Root
          label="Status"
          style={CAMPO.medio}
          value={filter.status}
          onChange={(status) => CPackagesReport.setFilter({ status })}
        >
          <Select.Option value="*">Todos</Select.Option>
          <Select.Option value="ABERTO">Em aberto</Select.Option>
          <Select.Option value="CONCLUIDO">Concluído</Select.Option>
        </Select.Root>

        <Input.Root
          label="CPF"
          mask="999.999.999-99"
          style={CAMPO.medio}
          value={filter.cpf}
          onChange={(cpf) => CPackagesReport.setFilter({ cpf })}
        />

        <Input.Root
          label="Cliente ou pet"
          placeholder="Nome completo ou parte dele"
          style={CAMPO.busca}
          value={filter.search}
          onChange={(search) => CPackagesReport.setFilter({ search })}
        />
      </Filter.Container>

      <Filter.Actions>
        <Filter.Action isLoading={isLoading}>
          <Filter.ActionIcon icon={FilterIcon} isLoading={isLoading} />
          Filtrar
        </Filter.Action>

        <Filter.Action
          outline
          type="button"
          name="clear-packages-report"
                    disabled={isLoading}
          onClick={CPackagesReport.clearFilter}
        >
          Limpar
        </Filter.Action>

        <Filter.Action
          outline
          type="button"
          name="export-packages-report"
          title="Exportar para Excel"
          disabled={isLoading || !total}
          onClick={CPackagesReport.reportExport}
        >
          <Filter.ActionIcon icon={Download} />
        </Filter.Action>
      </Filter.Actions>
    </Filter.Root>
  );
}
